<template>
  <div>
    <b-input-group class="filter-group">
      <b-input-group-prepend is-text>
        <font-awesome-icon icon="search" />
      </b-input-group-prepend>
      <b-form-input
        v-model="filter"
        placeholder="Type to Search"
      ></b-form-input>
      <b-input-group-append>
        <b-button @click="filter = null">Clear</b-button>
      </b-input-group-append>

      <b-button
        b-btn
        v-b-modal.notes-modal
        v-if="isStudentPlacementsManager"
        class="new-note-button"
        ><font-awesome-icon icon="plus" /> Add Note</b-button
      >
    </b-input-group>

    <b-table
      striped
      hover
      :items="notes"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="filter"
      @filtered="onFiltered"
      responsive
    >
      <template slot="createdDate" slot-scope="data">
        {{ data.item.createdDate | formatDate }}
      </template>
    </b-table>

    <b-modal
      @shown="focusNote"
      id="notes-modal"
      title="Add note"
      v-model="show"
    >
      <!-- element to gain focus when modal is opened -->
      <b-form-textarea
        ref="focusThis"
        v-model="noteText"
        placeholder="Enter notes"
        :rows="3"
        :max-rows="6"
      >
      </b-form-textarea>
      <b-form-checkbox name="visibleToStudent" v-model="visibleToStudent"
        >Visible to student</b-form-checkbox
      >
      <div slot="modal-footer">
        <b-btn variant="secondary" @click="show = false">Cancel</b-btn>
        <b-btn
          variant="primary"
          class="ml-2"
          @click="
            saveNote();
            show = false;
          "
          >Save</b-btn
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import studentApi from "../../api/student";
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],
  data() {
    return {
      fields: [
        { key: "createdDate", sortable: true },
        { key: "createdBy", sortable: true },
        { key: "notes", sortable: true },
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filter: null,
      noteText: "",
      visibleToStudent: false,
      show: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  props: {
    notes: {
      type: Array,
      required: true,
    },
    asuriteId: {
      required: true,
    },
    studentOpportunityId: {
      type: Number,
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    focusNote: function () {
      this.$refs.focusThis.focus();
    },

    saveNote: function () {
      var that = this;
      if (this.studentOpportunityId) {
        studentApi
          .postStudentOpportunityNote(
            this.asuriteId,
            this.studentOpportunityId,
            this.noteText,
            this.visibleToStudent
          )
          .then(function (response) {
            that.notes.push(response.data);
            that.noteText = "";
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        studentApi
          .postStudentNote(this.asuriteId, this.noteText, this.visibleToStudent)
          .then(function (response) {
            that.notes.push(response.data);
            that.noteText = "";
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
  },
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-note-button {
  margin-left: 10px;
}
</style>
